// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close:hover {
  color: black;
  background-color: transparent;
}

.modal-custom-lg .modal-dialog {
  position: fixed;
  top: 0%;
  bottom: 10%;
  left: 15.5%;
  width: 90%;
  height: 100%;
  margin-left: -10%;
}

.modal-custom-lg .modal-content {
  position: fixed;
  top: 0%;
  bottom: 10%;
  left: 15.5%;
  width: 90%;
  height: 100%;
  margin-left: -10%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
